export enum QuestionTypes {
  likert = 1,
  open = 2,
  multipleChoice = 3,
}
